module.exports = __webpack_public_path__ + "media/images/guarantee-e459ea73f6a00dd869d5dc0f18f7f4b2.png";